import React from 'react'
import PropTypes from 'prop-types'
import { Route, withRouter, Switch } from 'react-router'
import { LandingProvider, Home } from '@comunidade-iupp/landing'

import '@comunidade-iupp/landing/assets/theme/default/main.css'

const MeuNegocioRouter = ({ match: { url } }) => (
  <Switch>
    <LandingProvider authenticationUri={process.env.REACT_APP_COMUNIDADE_IUPP_SIGNUP}>
      <Route path={url} exact component={Home} />
    </LandingProvider>
  </Switch>
)

MeuNegocioRouter.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired
  })
}

export default withRouter(MeuNegocioRouter)



// WEBPACK FOOTER //
// ./src/HomeMeuNegocio/MeuNegocioRouter.js